import { computed, ComputedRef, ref, Ref } from '@vue/composition-api';
import { useContext } from '@berlin-front/common/composables/context';
import { defaultTheme, ThemeContext } from '@berlin-front/common/services/ThemeContext';

/**
 * アイコンのサイズ種別
 */
export const ICON_SIZE_MAP = {
  heading: 28,
  heading6: 20,
  subtitle1: 16,
  body2: 14,
  caption: 12,
} as const;

/**
 * テキストとアイコン間のマージンクラス作成
 */
export const useTextIconMarginClass = (textSize: Ref<string>): Ref<string> =>
  ref(`AppLink__Icon--margin_${textSize.value}`);

/**
 * atone以外のテーマカラーの場合のリンク色セット。
 * #1867C0は、Vuetify公式ページで利用されてるリンクの色。
 * normal, pressed, disabled全て#1867C0。
 */
const DEFAULT_LINK_COLOR_SET = {
  normal: '#1867C0',
  pressed: '#1867C0',
  disabled: '#1867C0',
};

/**
 * リンク色セットの型。
 */
export type LinkColorSetType = {
  normal: string;
  pressed: string;
  disabled: string;
};

/**
 * 最終的なリンクの色セットを返す。
 * atoneのテーマカラーであれば、それ専用の色セットを返す。
 * atoneのテーマカラーでなければ、DEFAULT_LINK_COLOR_SETを返す。
 */
export const useLinkColorSet = (): ComputedRef<LinkColorSetType> => {
  const { themeParameter } = useContext(ThemeContext);
  const primaryColor = computed(() => themeParameter.value.primaryColor);
  const primaryPressedColor = computed(() => themeParameter.value.primaryPressedColor);
  const primaryDisabledColor = computed(() => themeParameter.value.primaryDisabledColor);
  const linkColorSet = computed(() =>
    primaryColor.value === defaultTheme().primaryColor // atone
      ? {
          normal: primaryColor.value,
          pressed: primaryPressedColor.value,
          disabled: primaryDisabledColor.value,
        }
      : DEFAULT_LINK_COLOR_SET,
  );
  return linkColorSet;
};
